import { numberPattern } from '@app/shared/components/grid-controls/grid-text-field/grid-cell-value-patterns';
import GridTextField from '@app/shared/components/grid-controls/grid-text-field/GridTextField';
import { Alignment } from '@app/shared/enums/alignment.enum';
import { EquityBridgeColumnDto } from '@app/shared/models/contracts/project-dto';

type EquityBridgeBaseValueRowProps = {
  label: string;
  fieldKey: keyof Omit<EquityBridgeColumnDto, 'columnId' | 'role' | 'dateMemo' | 'netDebtValues'>;
  columns: { columnId: string }[];
};

const EquityBridgeBaseValueRow = ({ label, fieldKey, columns }: EquityBridgeBaseValueRowProps) => (
  <tr>
    <td className="table-primary__cell--vertical-separator">{label}</td>
    {columns.map((column, columnIndex) => (
      <td key={column.columnId}>
        <GridTextField
          name={`columns.${columnIndex}.${fieldKey}`}
          fieldValueMask={numberPattern}
          valueAsNumber
          placeholder="0"
          alignment={Alignment.Right}
        />
      </td>
    ))}
    <td />
  </tr>
);

export default EquityBridgeBaseValueRow;
